import styled from 'styled-components';
import { Button, Pagination } from 'antd';

export const CreateButton = styled(Button)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	height: 2.5rem;
	padding: 0.5rem;
	background: ${({ theme }) => theme.palette.primary[600]};
	border: none;
	border-radius: 0.25rem;
	box-shadow: none;
	color: ${({ theme }) => theme.palette.secondary.white};
	font-size: 1rem;
	line-height: 1.5rem;
	letter-spacing: -0.005rem;

	&:hover,
	&:focus {
		background: ${({ theme }) => theme.palette.primary[600]};
		color: ${({ theme }) => theme.palette.secondary.white};
	}

	svg {
		width: 1.5rem;
		height: 1.5rem;
	}
`;

export const Body = styled.div`
	padding: 0 0.5rem;
`;

export const EmptyState = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[300]};
	font-size: 1rem;
	line-height: 1.5rem;
`;

export const Total = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	line-height: 1rem;
`;

export const CardsPagination = styled(Pagination)`
	display: flex;
	align-items: center;

	.ant-pagination-item,
	.ant-pagination-prev,
	.ant-pagination-next {
		min-width: 2rem;
		height: 2rem;
		margin: 0 0.125rem;
		line-height: 2rem;
		border: none;
		border-radius: 0.25rem;
	}

	.ant-pagination-item {
		background: ${({ theme }) => theme.palette.secondary[100]};

		a {
			color: ${({ theme }) => theme.palette.secondary[250]};
			font-size: 0.875rem;
			font-weight: 600;
		}
	}

	.ant-pagination-item-active {
		background: ${({ theme }) => theme.palette.primary[100]};

		a {
			color: ${({ theme }) => theme.palette.primary.default};
		}
	}
`;
